import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const pancreatitis: AnswerPathTreeNode = {
  path: 'pancreatitis',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredPancreatitisDetails }],
};
